module.exports = __webpack_public_path__ + "img/architecture.bf94f8c4.png";